import { IPlot } from "@interfaces/IPlot";
import { IRunBlockRootScope } from "@interfaces/IRunBlockRootScope";
import { TranslationService } from "@services/translation.service";
import { ReasonCode } from "../enum/ReasonCode";
import { UnitConversionService, UnitConversionType } from "./unitConversion.service";
import { VeriDate } from "./veriDate.service";

export class ReasonCodeService {

    static $inject = ["$rootScope", "unitConversionService", "veriDate", "translationService"];

    constructor(
        private $rootScope: IRunBlockRootScope,
        private readonly unitConversionService: UnitConversionService,
        private readonly veriDate: VeriDate,
        private readonly translationService: TranslationService) {
        this.createStylesForReasonCodes();

        //setTimeout(() => {
        //    for (let item in ReasonCode) {
        //        if (!isNaN(Number(item))) {
        //            console.log("ReasonCode", item, this.getReasonCodeLabel(item as any));
        //        }
        //    }
        //}, 2000);
    }

    getReasonCodeLabel(reasonCode: ReasonCode): string {
        if (!reasonCode || !ReasonCode[reasonCode]) {
            return "";
        }

        var reasonCodeLabel = this.translationService.tEnum(ReasonCode, "ReasonCode", reasonCode);

        // This is stolen from splitPascalCase.filter, should be in a service?
        return reasonCodeLabel.replace(/([A-Z][a-z])/g, " $1").replace(/(\d)/g, " $1").trim();
    }

    createStatusText(plot: IPlot): string {
        if (!plot) {
            return "";
        }

        if (this.isTravelling(plot.Reason)) {
            if (plot.Velocity > 0) {
                return this.unitConversionService.convertUnitWithSuffix(plot.Velocity, UnitConversionType.Speed).toString();
            }
        }

        return this.translationService.t('reasonCodeService.stoppped');
    }

    isTravelling(reasonCode: ReasonCode): boolean {
        switch (reasonCode) {
            case ReasonCode.Wakeup:
            case ReasonCode.IgnitionOff:
            case ReasonCode.Unknown:
                return false;

            default:
                return true;
        }
    }

    isIgnitionOn(reasonCode: ReasonCode): boolean {
        if (!reasonCode) {
            return false;
        }

        switch (reasonCode) {
            case ReasonCode.IgnitionOff:
            case ReasonCode.Wakeup:
                return false;

            default:
                return true;
        }
    }

    getBackgroundColor(reasonCode: ReasonCode): string {

        switch (reasonCode) {
            case ReasonCode.Wakeup:
                return "#6e6e6e";

            case ReasonCode.IgnitionOn:
                return "#00ea1c";

            case ReasonCode.IgnitionOff:
                return "#FF4136";
                return "#ef0403"; // Previous colour

            // PTO
            case ReasonCode.Telematics:
                return "rgb(228,139,84)";

            case ReasonCode.Fms:
            case ReasonCode.FmsOn:
            case ReasonCode.FmsOff:
                return "#0295a7";

            case ReasonCode.Accelerometer:
            case ReasonCode.Crash:
                return "#add8e6";

            case ReasonCode.GeofenceCrossing:
                return "#800080";

            case ReasonCode.Unknown:
                return "#c2c2c2";

            default: // ReasonCode.TravelSend
                return "#FFDC00";
                return "#ffff00";//"#cccccc"; // previous colour
        }
    }

    getForegroundColor(reasonCode: ReasonCode) {

        const lightForegroundColour = "#eeeeee";
        const darkForegroundColour = "rgba(0,0,0,0.87)";

        const backgroundColour = this.getBackgroundColor(reasonCode);
        const foregroundColour = this.isHexColorDark(backgroundColour)
            ? lightForegroundColour
            : darkForegroundColour;

        return foregroundColour;
    }

    // -------------------------

    private createStylesForReasonCodes() {

        // Create styles
        this.$rootScope.runtimeStyles = this.$rootScope.runtimeStyles || "";

        for (let reasonCodeLabel in ReasonCode) {
            // Ensure we only get the string properties - see http://stackoverflow.com/a/30654325/94278
            if (ReasonCode.hasOwnProperty(reasonCodeLabel) && !/^\d+$/.test(reasonCodeLabel)) {

                const reasonCode = parseInt(ReasonCode[reasonCodeLabel]) as ReasonCode;

                const backgroundColour = this.getBackgroundColor(reasonCode);
                const foregroundColour = this.getForegroundColor(reasonCode);

                this.$rootScope.runtimeStyles += `.rc-${reasonCode}-background{background-color:${backgroundColour}!important;}`;
                this.$rootScope.runtimeStyles += `.rc-${reasonCode}-foreground{color:${backgroundColour}!important;}`;
                this.$rootScope.runtimeStyles += `.rc-${reasonCode}-text-contrast{color:${foregroundColour}!important;}`;
            }
        }
    }

    private isHexColorDark(color: string) {
        if (color.indexOf("#") === 0) {
            color = color.substring(1); // strip #
        }

        const rgb = parseInt(color, 16);   // convert rrggbb to decimal
        const r = (rgb >> 16) & 0xff;  // extract red
        const g = (rgb >> 8) & 0xff;  // extract green
        const b = (rgb >> 0) & 0xff;  // extract blue

        const luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709

        if (luma < 120) {
            // pick a different colour
            return true;
        }
        else {
            return false;
        }
    }
}
